import Button from 'components/ui-components/Button';
import { ArchiveIcon, UnarchiveIcon, DeleteIcon } from 'assets/icons';
import { messageModalTypes } from './approvals_groups_reducer';

const ApprovalsGroupsTable = ({
  headers,
  data,
  openModalHandler,
  sortGroupsHandler,
  sortTypes,
  skeletonScreen,
}) => {
  const skeletonArray = Array.from(Array(30).keys());

  const sortingIcon = header => {
    if (header === data.sort.type) {
      return data.sort.order === 'asc' ? ' ▲' : ' ▼';
    }
    return '';
  };

  return (
    <table className="approvals-table table table-striped">
      <thead>
        <tr>
          <th>
            <Button
              type="button"
              className="approvals-table__btn"
              handleClick={() => sortGroupsHandler(headers.name)}>
              {`${headers.name}${sortingIcon(sortTypes.name)}`}
            </Button>
          </th>
          <th>
            <Button
              type="button"
              className="approvals-table__btn"
              handleClick={() => sortGroupsHandler(headers.description)}>
              {`${headers.description}${sortingIcon(sortTypes.description)}`}
            </Button>
          </th>
          <th>
            <Button
              type="button"
              className="approvals-table__btn"
              handleClick={() => sortGroupsHandler(headers.status)}>
              {`${headers.status}${sortingIcon(sortTypes.status)}`}
            </Button>
          </th>
          <th>
            <Button
              type="button"
              className="approvals-table__btn"
              handleClick={() => sortGroupsHandler(headers.date)}>
              {`${headers.date}${sortingIcon(sortTypes.date)}`}
            </Button>
          </th>
          <th>
            <span className="hide-text">{headers.archive}</span>
          </th>
          <th>
            <span className="hide-text">{headers.delete}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {skeletonScreen &&
          skeletonArray.map((_, rowKey) => (
            <tr key={rowKey}>
              <td colSpan="10" className="skeleton skeleton__table-cell" />
            </tr>
          ))}
        {!skeletonScreen &&
          data.groups.map(group => (
            <tr key={group.id}>
              <td>
                <a href={group.edit_approval_group_url}>{group.name}</a>
              </td>
              <td>
                {group.description.length !== 0 ? group.description : '-'}
              </td>
              <td>{group.status}</td>
              <td>{group.created_at}</td>
              <td>
                <Button
                  className="approvals-table__icon approvals-table__icon--archive"
                  handleClick={() =>
                    openModalHandler(
                      group,
                      group.status === 'Active'
                        ? messageModalTypes.ARCHIVE
                        : messageModalTypes.UNARCHIVE,
                    )
                  }
                  aria-label={
                    group.status === 'Active' ? 'Archive' : 'Unarchive'
                  }>
                  {group.status === 'Active' ? (
                    <ArchiveIcon />
                  ) : (
                    <UnarchiveIcon />
                  )}
                  <span className="approvals-table__tooltip">
                    {group.status === 'Active' ? 'Archive' : 'Unarchive'}
                  </span>
                </Button>
              </td>
              <td>
                <Button
                  className="approvals-table__icon approvals-table__icon--delete"
                  handleClick={() =>
                    openModalHandler(group, messageModalTypes.DELETE)
                  }
                  aria-label="Delete">
                  <DeleteIcon />
                  <span className="approvals-table__tooltip">Delete</span>
                </Button>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ApprovalsGroupsTable;
